import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {emptyOrdersData} from './internalOrder';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchManualInvoiceData = (client, warehouse, agency) => apiActionCreator({
  'endpoint': `/transactions/parts/sales/manuals/warehouses/${warehouse}/clients/${client}/agencies/${agency}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_MANUAL_INVOICE_DATA,
    ActionTypes.FETCHED_MANUAL_INVOICE_DATA,
    [
      ActionTypes.FETCHED_MANUAL_INVOICE_DATA_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const addItemToManualOrder = (index, data) => apiActionCreator({
  'endpoint': '/transactions/parts/sales/manuals/items',
  'authenticated': true,
  'types': [
    ActionTypes.ADDING_ITEM_TO_MANUAL_ORDER,
    [
      {
        'type': ActionTypes.ADDED_ITEM_TO_MANUAL_ORDER,
        'payload': index,
      },
    ],
    [
      ActionTypes.ADDED_ITEM_TO_MANUAL_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const deleteItemFromManualOrder = (index, data) => apiActionCreator({
  'endpoint': '/transactions/parts/sales/manuals/items',
  'authenticated': true,
  'types': [
    ActionTypes.DELETING_ITEM_FROM_MANUAL_ORDER,
    [
      {
        'type': ActionTypes.DELETED_ITEM_FROM_MANUAL_ORDER,
        'payload': index,
      },
      MessageActions.addMessageBoxInfo('Item eliminado satisfactoriamente'),
    ],
    [
      ActionTypes.DELETED_ITEM_FROM_MANUAL_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
  'contentType': 'application/json',
  'data': data,
});

export const addOrderCodeToInvoice = (orderCode) => ({
  'type': ActionTypes.ADD_ORDER_CODE_TO_INVOICE,
  'payload': orderCode,
});

export const removeOrderCodeToInvoice = (orderCode) => ({
  'type': ActionTypes.REMOVE_ORDER_CODE_TO_INVOICE,
  'payload': orderCode,
});

export const saveInvoice = (type, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/transactions/parts/sales/${type}`,
      'authenticated': true,
      'types': [
        ActionTypes.SAVING_INVOICE,
        [
          () => {
            dispatch(emptyOrdersData());
            return {
              'type': ActionTypes.SAVED_INVOICE,
            };
          },
          (response) => MessageActions.addMessageBoxInfo(response.data.message),
        ],
        [
          ActionTypes.SAVED_INVOICE_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    }),
  );
};
